import { type MouseEvent, type KeyboardEvent, type FC, useEffect, useRef, useState } from "react";
import { TextButton } from "@root/shared/components/TextButton";
import { Icon } from "@root/shared/components/Icon";
import { MultiLineText } from "@root/shared/components/MultiLineText";
import * as styles from "./styles.css";

type Props = {
  message: string;
  className?: string;
};

const PREMIUM_MESSAGE_DEFAULT_HEIGHT = 54;

export const PremiumMessage: FC<Props> = ({ message, className }) => {
  const premiumMessageRef = useRef<HTMLDivElement>(null);
  const [isOpenMessage, setIsOpenMessage] = useState(false);
  const handleOpenAccordion = () => {
    setIsOpenMessage(true);
  };

  // プレミアムスカウトメッセージが短い場合は画面描画時にアコーディオンを解除する
  useEffect(() => {
    if (premiumMessageRef?.current) {
      const { scrollHeight } = premiumMessageRef.current;

      if (scrollHeight <= PREMIUM_MESSAGE_DEFAULT_HEIGHT) {
        setIsOpenMessage(true);
      }
    }
  }, []);

  return (
    <div
      className={`${styles.messageBox} ${className ?? ""}`}
      onClick={(e: MouseEvent) => e.preventDefault()}
      onKeyDown={(e: KeyboardEvent<HTMLDivElement>) => e.preventDefault()}
      role="button"
      tabIndex={0}
    >
      <p className={styles.messageHeader}>
        <span className={styles.messageIcon}>
          <Icon name="human" />
        </span>
        企業担当者からのメッセージ
      </p>
      <div className={styles.message}>
        <div className={styles.messageInner({ isOpen: isOpenMessage })} ref={premiumMessageRef}>
          <MultiLineText text={message} />
        </div>
        {!isOpenMessage && (
          <div className={styles.messageReadMoreButtonOuter}>
            <TextButton
              size="small"
              onClick={handleOpenAccordion}
              className={styles.messageReadMoreButton}
            >
              続きを見る
            </TextButton>
          </div>
        )}
      </div>
    </div>
  );
};
